"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESocialType = void 0;
let ESocialType = exports.ESocialType = /*#__PURE__*/function (ESocialType) {
  ESocialType["VK"] = "vk";
  ESocialType["Facebook"] = "fb";
  ESocialType["OK"] = "ok";
  ESocialType["Google"] = "google";
  ESocialType["MailRu"] = "mailRuAccount";
  ESocialType["AppleID"] = "appleid";
  ESocialType["Gosuslugi"] = "gosuslugi";
  return ESocialType;
}({});